import * as React from 'react'

import { AButton } from '../../components/atoms'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import { acceptEula } from '../../data/auth/auth.actions'
import { LandingTitleContent } from '../../pages/PLanding'
import AButtonGroup from '../../components/atoms/AButtonGroup'
import { BrandingContext } from '../../context/BrandingContext'

export interface IEula extends IApiConsumer {
    onSuccess?: () => void
}

class Eula extends React.Component<IEula> {
    handleSubmit = () => {
        return this.props
            .dispatch(acceptEula())
            .then(() => {
                this.setState({ isEulaAccepted: true })
                window.location.reload()
            })
    }

    handleCancel = () => {
        localStorage.removeItem('refresh-token')
        localStorage.removeItem('token')
        window.location.reload()
    }

    render() {
        return (
            <BrandingContext.Consumer>
                {config => (
                    <div>
                        <LandingTitleContent>Please agree to the terms of service to continue</LandingTitleContent>
                        <embed
                            src={`/${config.eulaFile}`}
                            type="application/pdf"
                            height="520"
                            width="100%"
                        />
                        <AButtonGroup>
                            <AButton style={{ height: '42px' }} onClick={this.handleSubmit} block color="primary">
                                Yes
                            </AButton>
                            <AButton style={{ height: '42px' }} onClick={this.handleCancel} block color="error">
                                No
                            </AButton>
                        </AButtonGroup>
                    </div>
                )}
            </BrandingContext.Consumer>
        )
    }
}

export default apiConsumer({})(Eula)
